import type { BlockKind } from "../types";

/** Every physics knob in one place. The game reads `tuning`; only /demo/physics mutates it. */
export interface PhysicsTuning {
  /** Projectile params per score tier 0-4. */
  massTiers: number[];
  speedTiers: number[];
  blastTiers: number[];
  /** Launch speed range in px/s; speedPosition interpolates between them. */
  speedMin: number;
  speedMax: number;
  gravity: number;
  airDrag: number;
  floorBounce: number;
  floorFriction: number;
  /** Share of speed kept per durability point broken by a mass-1 ball on glass. */
  retainBase: number;
  /** How strongly √mass raises the kept share. */
  massResistance: number;
  /** The ball stops (and blasts) below this share of its launch speed. */
  stopRatio: number;
  maxFlightSeconds: number;
  blastOnExit: boolean;
  /** BLAST tier from which Space/tap detonates the ball mid-flight. */
  detonateMinTier: number;
  /** Share of speed the ball keeps after a manual blast. */
  detonateSpeedKeep: number;
  materials: Record<BlockKind, number>;
}

export const defaultTuning: PhysicsTuning = {
  massTiers: [1, 2.5, 3.8, 5, 7],
  speedTiers: [0.08, 0.18, 0.5, 0.82, 0.95],
  blastTiers: [0, 25, 50, 90, 140],
  speedMin: 700,
  speedMax: 1000,
  gravity: 650,
  airDrag: 0.1,
  floorBounce: 0.12,
  floorFriction: 0.72,
  retainBase: 0.3,
  massResistance: 1.2,
  stopRatio: 0.07,
  maxFlightSeconds: 5,
  blastOnExit: true,
  detonateMinTier: 2,
  detonateSpeedKeep: 0.7,
  materials: { glass: 1, laminated: 0.94, brick: 0.78, core: 0.88, resonance: 0.88, dampener: 0.24 },
};

export const tuning: PhysicsTuning = structuredClone(defaultTuning);

export function setTuning(next: PhysicsTuning) {
  Object.assign(tuning, structuredClone(next));
}
